/**
 * Clinic portal clinic locations API service.
 * Pure functions for clinic location list and detail operations. No React or localStorage.
 */

import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import type {
  ClinicLocationListData,
  ClinicLocationSearchParams,
  ClinicLocation,

} from '@/pages/main/clinicLocation/types';

export type { ClinicLocationSearchParams };

/**
 * API Response wrapper
 */
interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  errors?: Record<string, string>;
}

/**
 * Convert search params to query params.
 */
function toParams(
  params: ClinicLocationSearchParams | undefined
): Record<string, string | number> {
  const result: Record<string, string | number> = {};
  if (!params) return result;
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value;
    }
  });
  return result;
}

/**
 * Get paginated list of clinic locations.
 */
export async function getClinicLocationsList(
  siteType: string,
  clinicNumber: string,
  params: ClinicLocationSearchParams | undefined,
  serviceType: string
): Promise<ApiResponse<ClinicLocationListData>> {
  const response = await apiClient.get<ApiResponse<ClinicLocationListData>>(
    clinicApiPath(siteType, clinicNumber, '/clinic-locations'),
    {
      params: toParams(params),
      headers: {
        'X-Service-Type': serviceType,
      },
    }
  );
  return response.data;
}

/**
 * Get a single clinic location by ID.
 */
export async function getClinicLocationById(
  siteType: string,
  clinicNumber: string,
  id: number,
  serviceType: string
): Promise<ApiResponse<ClinicLocation>> {
  const response = await apiClient.get<ApiResponse<ClinicLocation>>(
    clinicApiPath(siteType, clinicNumber, `/clinic-locations/${id}`),
    {
      headers: {
        'X-Service-Type': serviceType,
      },
    }
  );
  return response.data;
}




